import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicModule } from 'ionic-angular';
import { HttpModule } from "@angular/http";
import { NgUploaderModule } from 'ngx-uploader';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Md2DatepickerModule } from 'md2';

import { MyApp } from './app.component';

import { ApiService } from '../providers/api.service';
import { AuthService } from '../providers/auth.service';
import { MobileDetectorProvider } from '../providers/mobile-detector';
import { SentryErrorHandler } from "../providers/sentry.service";
import { SearchService } from "../providers/search.service";
import { FilterService } from "../providers/filter.service";

import { IonicStorageModule } from '@ionic/storage'
import { DataService } from '../providers/data-service';
import { ConfigService } from "../providers/config.service";
import { AlertService } from '../providers/alert.service';
import { ValidationService } from '../providers/validation.service';

@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    BrowserModule,
    HttpModule,
    NgUploaderModule,
    Md2DatepickerModule,
    BrowserAnimationsModule,
    IonicModule.forRoot(MyApp, {}, 
{
  links: [
    { loadChildren: '../components/filter-modal/filter-modal.module#FilterModalComponentModule', name: 'filter-modal', segment: 'filter-modal', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/create-offer/create-offer.module#CreateOfferPageModule', name: 'create', segment: 'create/:type/:offerId', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/create-offer-landing/create-offer-landing.module#CreateOfferLandingPageModule', name: 'create-landing', segment: 'create-landing', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/detail/detail.module#DetailPageModule', name: 'detail', segment: 'detail/:type/:id', priority: 'low', defaultHistory: ['home'] },
    { loadChildren: '../pages/home/home.module#HomePageModule', name: 'home', segment: 'home', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/login/login.module#LoginPageModule', name: 'login', segment: 'login', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/profile/profile.module#ProfilePageModule', name: 'profile', segment: 'profile', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/request-password/request-password.module#RequestPasswordPageModule', name: 'request-pw', segment: 'request-pw', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/reset-password/reset-password.module#ResetPasswordPageModule', name: 'pwreset', segment: 'pwreset/:code', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/sibboleth-login/sibboleth-login.module#SibbolethLoginPageModule', name: 'shib_login', segment: 'shib_login/:args', priority: 'low', defaultHistory: [] }
  ]
}),
    IonicStorageModule.forRoot({
      name: '__imarktdb',
      driverOrder: ['localstorage']
    })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [
    { provide: ErrorHandler, useClass: SentryErrorHandler },
    ApiService,
    AuthService,
    MobileDetectorProvider,
    SearchService,
    FilterService,
    DataService,
    ConfigService,
    AlertService,
    ValidationService
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts